import {
  FaGithubAlt,
  FaInstagram,
  FaLinkedinIn,
  FaBootstrap,
  FaCode,
  FaCss3Alt,
  FaFigma,
  FaHtml5,
  FaJs,
  FaLaptopCode,
  FaMobileAlt,
  FaPencilRuler,
  FaReact,
  FaFacebookF,
} from "react-icons/fa";
import mypict from "../assets/mypict.jpg";
import heroshape from "../assets/heroshape.png";
import webPM from "../assets/projects/website pm.png";
import webSIPM from "../assets/projects/web sipm.png";
import sipm from "../assets/projects/sipm.png";
import sportscore from "../assets/projects/sportscore.png";
import todoes from "../assets/projects/todoes.jpg";
import menghitungangka from "../assets/projects/menghitung angka.png";

import logisticLanding from '../assets/projects/logistic landing.png'
import appointmentWidget from '../assets/projects/appointment widget.png'
import groceryApp from '../assets/projects/grocery app.png'
import planPurchase from '../assets/projects/plan purchase.png'
import productLanding from '../assets/projects/product landing page.png'

import halalinkamu from '../assets/projects/halalinkamu.png'
import srirejeki from '../assets/projects/srirejeki.png'

export const base_url = 'https://akbarputra04.github.io/'

export const myPict = mypict;

export const heroShape = heroshape;

export const menus = [
  {
    id: 1,
    title: "Home",
    url: "#home",
  },
  {
    id: 2,
    title: "About",
    url: "#about",
  },
  {
    id: 3,
    title: "My Skills",
    url: "#skills",
  },
  {
    id: 4,
    title: "Portfolio",
    url: "#portfolio",
  },
  {
    id: 5,
    title: "Contact",
    url: "#contact",
  },
];

export const socials = [
  {
    id: 1,
    icon: <FaGithubAlt color="white" />,
    url: "https://github.com/Akbarputra04",
  },
  {
    id: 2,
    icon: <FaLinkedinIn color="white" />,
    url: "https://linkedin.com/in/akbar-putra-4b7982149",
  },
  {
    id: 3,
    icon: <FaInstagram color="white" />,
    url: "https://instagram.com/akbar_putra04",
  },
  {
    id: 4,
    icon: <FaFacebookF color="white" />,
    url: "https://facebook.com/akbar.pangestu.96",
  },
];

export const stats = [
  {
    id: 1,
    title: "2+",
    desc: "Years in the field",
  },
  {
    id: 2,
    title: "14",
    desc: "Completed project",
  },
  {
    id: 3,
    title: "6",
    desc: "Satisfied client",
  },
  {
    id: 4,
    title: "5",
    desc: "Certification",
  },
];

export const Skills = [
  {
    id: 1,
    title: "Coding",
    techs: [{title: 'HTML', icon: <FaHtml5 />}, {title: 'CSS', icon: <FaCss3Alt />}, {title: 'javascript', icon: <FaJs />}],
    icon: <FaCode color="white" size={26} />,
  },
  {
    id: 2,
    title: "Website design",
    techs: [{title: 'bootstrap', icon: <FaBootstrap />}, {title: 'reactJS', icon: <FaReact />}],
    icon: <FaLaptopCode color="white" size={26} />,
  },
  {
    id: 3,
    title: "App design",
    techs: [{title: 'react native', icon: <FaReact />}],
    icon: <FaMobileAlt color="white" size={26} />,
  },
  {
    id: 4,
    title: "UI/UX design",
    techs: [{title: 'figma', icon: <FaFigma />}],
    icon: <FaPencilRuler color="white" size={26} />,
  },
];

export const projects = [
  {
    id: 1,
    title: "Website PM",
    country: "Indonesia",
    category: 'web',
    thumb: webPM,
    link: 'https://pm.mojohuro.com',
    featured: false,
  },
  {
    id: 2,
    title: "todoes - task list management",
    country: "Indonesia",
    category: 'mobile',
    thumb: todoes,
    link: 'https://play.google.com/store/apps/details?id=com.todoes',
    featured: true,
  },
  {
    id: 3,
    title: "plan purchase website",
    country: "Indonesia",
    category: 'uiux',
    thumb: planPurchase,
    link: planPurchase,
    featured: false,
  },
  {
    id: 4,
    title: "product landing page",
    country: "Indonesia",
    category: 'uiux',
    thumb: productLanding,
    link: productLanding,
    featured: false,
  },
  {
    id: 5,
    title: "SIPM - sistem informasi pemuda",
    country: "indonesia",
    category: 'mobile',
    thumb: sipm,
    link: 'https://play.google.com/store/apps/details?id=com.sipm',
    featured: true,
  },
  {
    id: 6,
    title: "grocery & shop app",
    country: "Indonesia",
    category: 'uiux',
    thumb: groceryApp,
    link: groceryApp,
    featured: false,
  },
  {
    id: 7,
    title: "logistic landing - banner for logistic website",
    country: "Argentina",
    category: 'uiux',
    thumb: logisticLanding,
    link: logisticLanding,
    featured: true,
  },
  {
    id: 8,
    title: "appointment widget",
    country: "Ireland",
    category: 'uiux',
    thumb: appointmentWidget,
    link: appointmentWidget,
    featured: false,
  },
  {
    id: 9,
    title: "Web application SIPM",
    country: "Indonesia",
    category: 'web',
    thumb: webSIPM,
    link: 'https://sipm.mojohuro.com',
    featured: false,
  },
  {
    id: 10,
    title: "sportscore - scoreboard for various sports",
    country: "Indonesia",
    category: 'mobile',
    thumb: sportscore,
    link: 'https://play.google.com/store/apps/details?id=com.akbarputra.sportscore',
    featured: false,
  },
  {
    id: 11,
    title: "todoes add design",
    country: "Indonesia",
    category: 'uiux',
    thumb: todoes,
    link: todoes,
    featured: false,
  },
  {
    id: 12,
    title: "menghitung angka - arithmetic games",
    country: "Indonesia",
    category: 'mobile',
    thumb: menghitungangka,
    link: 'https://play.google.com/store/apps/details?id=com.menghitungangka.menghitungangka',
    featured: false,
  },
  {
    id: 13,
    title: "halalinkamu - undangan pernikahan digital",
    country: "Indonesia",
    category: 'web',
    thumb: halalinkamu,
    link: 'https://halalinkamu.com',
    featured: true,
  },
  {
    id: 14,
    title: "srirejeki.store - online shop",
    country: "Indonesia",
    category: 'web',
    thumb: srirejeki,
    link: 'https://srirejeki.store',
    featured: true,
  },
];
